import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useLocation hook
import ArrowedIcon from '../../assets/icons/Back-btn.svg'; // Import your icon
import { Button } from 'antd';

const OnBoardingHead = ({ heading, subheading,type }) => {
  const location = useLocation(); // Get the current location
  const navigate = useNavigate();

  // Check if the current path is '/vessel-details'
  const isVesselDetailsPage = location.pathname === '/dashboard';

  return (
    <div className="onboarding-header">
      <div className="onboarding-title">
        {/* Only render the icon if not on '/vessel-details' page */}
        {(!type=="vessel" || type=="new" || type=="edit") && (
          <Button
          onClick={() => navigate(-1)}
          prefix={ArrowedIcon}
          style={{
            padding: 0, // Remove default padding
            border: "none", // Remove border for clean appearance
            background: "none", // Transparent background
            display: "inline-flex", // Align button with icon size
            alignItems: "center", // Center-align the icon
            justifyContent: "center", // Center-align the icon
          }}
        >
          <img
            src={ArrowedIcon}
            alt="Back Icon"
            className="onboarding-icon"
          />
        </Button>
          
        )}
        {type=="new" || type=="vessel" || type=="edit" || type=="notifications" || type=="pool_overview" || type=="manual_pool" || type=="estimation" ?
          <div>
            <span className="onboarding-heading">
              {heading}
            </span>
            <p className="onboarding-subheading">
              {subheading}
            </p>
          </div>
        :""}
      </div>
      {/* {!isVesselDetailsPage && type==("new" || "vessel") && <hr className="onboarding-divider" />} */}
    </div>
  );
};

export default OnBoardingHead;
